export const driverGrid = {
  vehicleTypeBox: {
    display: "flex",
    height: "39px",
    alignItems: "center",
    alignText: "left",
  },
  vehicleTypeText: {
    fontSize: "14px",
  },
  dataBox: {
    display: "flex",
    height: "39px",
    alignItems: "center",
    textAlign: "left",
  },
  dataText: {
    fontSize: "14px",
  },
  statusForm: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  mainBox: {
    display: "flex",
    width: "100%",
    height: "40px",
    alignItems: "center",
    columnGap: "8px",
    cursor: "pointer",
    textDecoration:'underline'
  },
  iconButton: {
    backgroundColor: "#CF0A2C",
    borderRadius: "5px",
    width: "28px",
    height: "28px",
  },
  icon: {
    padding: 0,
    margin: 0,
    color: "white",
  },
  dialogBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "24px",
  },
  dialogText: {
    fontSize: "18px",
    fontWeight: "600",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  generalData: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  contentSubWrapper: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // 3 colonne
    gap: 2, // Distanza tra gli elementi,
    margin: "8px 0 16px 0",
  },
  box: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
  },
  box1: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    alignItems: "center",
  },
  text: {
    fontSize: "14px",
    color: "#CF0A2C",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  text1: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  box2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  box3: {
    display: "flex",
    flexDirection: "column",
    margin: "8px 0 0 0",
  },
  text2: {
    fontSize: "14px",
    color: "#CF0A2C",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  box4: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    alignItems: "center",
  },
  box5: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
    alignItems: "center",
  },
  box6: {
    display: "flex",
    flexDirection: "row",
    columnGap: "8px",
  },
  button: {
    height: "37px",
    backgroundColor: "#CF0A2C",
  },
};

export const driverDrawer = {
  wrapper: {
    height: "100vh",
    display:'flex',
    flexDirection:'column'
  },
  headerWrapper: {
    
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink:0,
  },
  headerTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#333333",
  },
  headerSubtitleWrapper: {
    display: "flex",
    flexDirection: "column",
    
    rowGap: "16px",
    flexGrow:1,
    overflow:'auto'
  },
  headerSubtitle: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "#333333",
  },
  plateCategoryWrapper: {
    width: "100%",
    display: "flex",
    
    justifyContent: "space-between",
    columnGap: "8px",
  },
  generalBox:{
    display: "flex", flexDirection: "column", width: "100%" 
  },
  mainText:{
    fontSize: "14px",
    color: "#CF0A2C",
    textTransform: "uppercase",
    fontWeight:'600'
  },
  textField:{
    "& .MuiOutlinedInput-root": {
      height: 41, // Altezza desiderata
      "& fieldset": {
        borderColor: "gray", // Colore del bordo normale
      },
      "&:hover fieldset": {
        borderColor: 'gray', // Colore del bordo al passaggio del mouse
      },
      "&.Mui-focused fieldset": {
        borderColor: 'gray', // Colore del bordo quando è attivo
      },
    },
  },
  selectComponent:{
    
    height: 41, // Altezza personalizzata
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "gray", // Colore del bordo normale
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: 'gray', // Colore del bordo al passaggio del mouse
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: 'gray', // Colore del bordo quando è attivo
    },
    
  },
  autocompleteComponent:{
    height: "41px", // Imposta altezza per l'input
    "& .MuiOutlinedInput-root": {
      height: "41px", // Imposta altezza anche sul root dell'input
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "gray", // Colore del bordo normale
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: '#CF0A2C', // Colore del bordo quando è attivo
    },
    
    // Eventuali altre personalizzazioni per l'input
  },
  autocompleteComponent2:{
    height: "30px", // Imposta altezza per l'input
    "& .MuiOutlinedInput-root": {
      height: "30px", // Imposta altezza anche sul root dell'input
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "gray", // Colore del bordo normale
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: '#CF0A2C', // Colore del bordo al passaggio del mouse
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: '#CF0A2C', // Colore del bordo quando è attivo
    },
    "& .MuiInputBase-input": {
      fontSize: "14px", // Modifica la dimensione del font dentro l'input
    },
  },
  autocompleteOptions: {
    "& .MuiAutocomplete-listbox": {
      fontSize: "12px",
    },
  },
  documentBox:{
    display: "flex", alignItems: "center", gap: 2
  },
  uploadBox:{
    fontSize: "14px",
    textDecoration: "underline",
    color: "#CF0A2C",
    cursor:'pointer'
  },
  statusBox:{
    columnGap: "8px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  divider:{
    mt: 2, position: "absolute", bottom: "88px", width: "100%" 
  },
  button:{
    mt: 2,
    position: "absolute",
    bottom: "24px",
   
   
    backgroundColor: "#CF0A2C",
  }
  
};
